import { useCallback, useEffect, useState } from "react";
import { api } from "@/api";
import { useNavigate, useParams } from "react-router-dom";
import useErrorHandling from "@/hooks/useErrorHandling";
import { toast } from "react-toastify";
import { OfficeForm, OfficeFormData } from "@/app/components/office/OfficeForm";
import { ModalError } from "@/app/components/modals/modalBuilder";
import { normalizeDate } from "@/utils";
export function EditOfficePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const handleError = useErrorHandling();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState<Partial<OfficeFormData>>();

  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);

  useEffect(() => {
    if (!id) return;

    api.offices
      .get(Number(id))
      .then((response) => {
        const office = response.data;
        setDefaultValues({
          display_name: office.display_name,
          // @ts-expect-error office_type is a string
          office_type: String(office.office_type),
          area: office.area,
          price: office.price,
          room_count: office.room_count,
          // @ts-expect-error location is a string
          location: String(office.location),
          floor: office.floor,
          office_lock: office.office_lock,
          commissioning_date: normalizeDate(office.commissioning_date),
          workplace_count: office.workplace_count,
          ceiling_height: office.ceiling_height,
          description: office.description,
          finishing: office.finishing,
          main_photo: office.main_photo,
          additional_photos: office.additional_photos,
          min_period: office.min_period,
          public: office.public,
          features: office.features,
        });
      })
      .catch((err) => {
        const { errorMessage, parsedErrors } = handleError(err);
        setModalErrors(parsedErrors || []);
        toast.error(errorMessage);
        navigate("/dashboard/offices");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id, navigate, handleError, setModalErrors]);

  const onSubmit = useCallback(
    (data: OfficeFormData) => {
      if (!id) return;
      console.log(data.office_lock);
      api.offices
        .update(Number(id), {
          display_name: data.display_name,
          office_type: Number(data.office_type),
          area: data.area,
          floor: data.floor,
          office_lock: data.office_lock || undefined,
          price: data.price,
          room_count: data.room_count,
          location: Number(data.location),
          commissioning_date: data.commissioning_date + "T00:00:00",
          workplace_count: data.workplace_count,
          ceiling_height: data.ceiling_height,
          description: data.description,
          finishing: data.finishing,
          main_photo: data.main_photo || undefined,
          additional_photos: data.additional_photos,
          min_period: data.min_period,
          public: data.public,
          features: data.features,
        })
        .then(() => {
          toast.success("Офис успешно обновлен");
          navigate("/dashboard/offices");
        })
        .catch((err) => {
          const { errorMessage } = handleError(err);
          toast.error(errorMessage);
        });
    },
    [id, navigate, handleError],
  );

  const onDelete = useCallback(() => {
    return new Promise<boolean>((resolve) => {
      if (!id) return resolve(false);

      api.offices
        .delete(Number(id))
        .then(() => {
          toast.success("Офис успешно удален");
          navigate("/dashboard/offices");
          resolve(true);
        })
        .catch((err) => {
          const { errorMessage } = handleError(err);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  }, [id, navigate, handleError]);

  if (isLoading) {
    return <div>Загрузка...</div>;
  }

  return (
    <>
      <h1 className="text-xl font-bold mb-4">Редактирование офиса</h1>
      <OfficeForm
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        onDelete={onDelete}
        isEdit={true}
        modalErrors={modalErrors}
        officeId={Number(id)}
      />
    </>
  );
}
